import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetogoacab() {



const cardData = {
  keyword: " Pune to Goa Cab ",

"headingDescription": "Pune to Goa Cab service offers a comfortable, scenic, and reliable travel experience for passengers planning a trip from Pune to Goa. Whether it’s a vacation, honeymoon, family trip, or group travel, our professional drivers and well-maintained vehicles ensure a smooth ride through the Western Ghats. We provide one-way trips, round trips, and customized travel packages with transparent pricing and no hidden charges. With SRS Pune to Goa Cab, enjoy easy online booking, 24/7 customer support, and a relaxing journey to India’s most popular beach destination.",
"topPlaces": [
  {
    "title": "Baga Beach",
    "description": "Baga Beach is one of the most popular beaches in Goa, known for water sports and nightlife. Travelers booking Pune to Goa Cab often visit this beach for fun activities and vibrant atmosphere."
  },
  {
    "title": "Calangute Beach",
    "description": "Calangute Beach is the largest beach in North Goa, famous for its golden sand and lively environment. Visitors using Pune to Goa Cab enjoy relaxing and exploring beachside markets here."
  },
  {
    "title": "Anjuna Beach",
    "description": "Anjuna Beach is known for its scenic beauty and flea market. Travelers using Pune to Goa Cab often explore this beach for shopping, music, and sunset views."
  },
  {
    "title": "Dudhsagar Waterfalls",
    "description": "Dudhsagar Waterfalls is a spectacular four-tiered waterfall located on the Goa-Karnataka border. Visitors traveling via Pune to Goa Cab enjoy this natural attraction for its breathtaking beauty."
  },
  {
    "title": "Basilica of Bom Jesus",
    "description": "Basilica of Bom Jesus is a UNESCO World Heritage Site famous for housing the relics of St. Francis Xavier. Travelers using Pune to Goa Cab visit this church for its religious and historical importance."
  },
  {
    "title": "Fort Aguada",
    "description": "Fort Aguada is a well-preserved Portuguese fort offering panoramic sea views. Visitors booking Pune to Goa Cab explore this site for its history and scenic surroundings."
  },
  {
    "title": "Chapora Fort",
    "description": "Chapora Fort is known for its stunning views of Vagator Beach and surrounding areas. Travelers using Pune to Goa Cab often visit this fort for photography and sunsets."
  },
  {
    "title": "Palolem Beach",
    "description": "Palolem Beach is a peaceful and scenic beach in South Goa. Visitors using Pune to Goa Cab enjoy relaxing here away from the crowds and enjoying calm waters."
  },
  {
    "title": "Colva Beach",
    "description": "Colva Beach is a popular beach in South Goa known for its white sand and palm trees. Travelers booking Pune to Goa Cab visit this beach for leisure and water activities."
  },
  {
    "title": "Dona Paula",
    "description": "Dona Paula is a famous viewpoint and tourist attraction offering scenic views of the Arabian Sea. Visitors using Pune to Goa Cab often visit this spot for photography and sightseeing."
  }
],



services: [
{
name: "Pune to Goa Cab Service",
description: "Pune to Goa cab service offers reliable long-distance travel for beach vacations. Customers can book cabs for comfortable highway journeys. Professional drivers ensure safe and smooth travel. Comfortable vehicles enhance long-distance experience. Flexible booking options are available. Travel easily from Pune to Goa with cab services."
},
{
name: "Pune to Goa Cab Booking",
description: "Pune to Goa cab booking provides quick and easy reservation options for travelers. Customers can book cabs online or via mobile apps. Professional drivers ensure safe journeys. Comfortable vehicles enhance travel comfort. Flexible booking options are available. Book your Pune to Goa cab easily."
},
{
name: "Pune to Goa Rental Cabs",
description: "Pune to Goa rental cabs offer flexible vehicle options for long-distance trips. Customers can choose from sedan, SUV, and premium cars. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Transparent pricing ensures affordability. Rent cabs from Pune to Goa for convenient travel."
},
{
name: "Pune to Goa One-Way Cab",
description: "Pune to Goa one-way cab offers economical travel without return charges. Customers can book direct one-way rides easily. Professional drivers ensure safe journeys. Comfortable vehicles enhance travel experience. Transparent pricing ensures affordability. Choose one-way cab services for Pune to Goa travel."
},
{
name: "Pune to Goa Round Trip Cabs",
description: "Pune to Goa round trip cabs provide convenient two-way travel options. Customers can plan return journeys with flexible schedules. Comfortable vehicles ensure smooth travel. Professional drivers ensure safe journeys. Transparent pricing ensures value for money. Book round trip cabs for Pune to Goa trips."
},
{
name: "Pune to Goa Luxury Taxi",
description: "Pune to Goa luxury taxi offers premium travel experience for long-distance journeys. Customers can enjoy high-end vehicles with extra comfort. Professional chauffeurs ensure safe travel. Ideal for family and corporate trips. Flexible booking options are available. Experience luxury travel from Pune to Goa."
},
{
name: "Pune to Goa Cabs",
description: "Pune to Goa cabs provide reliable transportation for beach trips and vacations. Customers can choose from multiple vehicle options. Professional drivers ensure safe journeys. Comfortable vehicles enhance travel experience. One-way and round trip options are available. Travel easily from Pune to Goa with cab services."
},
{
name: "Pune to Goa Car Rental",
description: "Pune to Goa car rental offers flexible vehicle options for long-distance travel. Customers can rent cars for personal or business trips. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Transparent pricing ensures affordability. Rent cars from Pune to Goa for convenient travel."
},
{
name: "Pune to Goa Taxi",
description: "Pune to Goa taxi service provides convenient transportation for long-distance travel. Customers can book taxis for leisure and business trips. Professional drivers ensure safe journeys. Comfortable vehicles enhance travel comfort. Flexible booking options are available. Travel easily from Pune to Goa with taxi services."
},
{
name: "Pune to Goa Taxi Fare",
description: "Pune to Goa taxi fare provides estimated pricing for travel planning. Customers can check fare details before booking rides. Affordable pricing ensures budget-friendly travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Choose taxi services with transparent fare for Goa trips."
},
{
name: "Pune to Goa Cab Package",
description: "Pune to Goa cab package offers complete travel solutions for vacation trips. Customers can choose multi-day packages for beach visits. Comfortable vehicles ensure smooth journeys. Professional drivers ensure safe travel. Transparent pricing ensures value for money. Book cab packages from Pune to Goa easily."
},
{
name: "Pune to Goa Cab Fare",
description: "Pune to Goa cab fare provides clear pricing details for long-distance travel. Customers can compare fares before booking rides. Affordable pricing ensures cost-effective journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Travel confidently with cab fare services to Goa."
},
{
name: "Best Cab Service from Pune to Goa",
description: "Best cab service from Pune to Goa offers top-quality travel experience. Customers can enjoy reliable service and comfortable vehicles. Professional drivers ensure safe journeys. Flexible booking options are available. Transparent pricing ensures value for money. Choose the best cab service for Pune to Goa travel."
},
{
name: "Cab Service from Pune to Goa",
description: "Cab service from Pune to Goa provides dependable transportation for long-distance trips. Customers can book cabs for business or leisure travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance travel experience. Flexible booking options are available. Travel easily from Pune to Goa with cab services."
},
{
name: "Car Hire Pune to Goa",
description: "Car hire Pune to Goa offers flexible travel solutions for long-distance trips. Customers can hire cars with or without drivers. Comfortable vehicles ensure smooth journeys. Professional drivers ensure safe travel. Transparent pricing ensures affordability. Hire cars from Pune to Goa for convenient travel."
},
{
name: "One Way Cab from Pune to Goa",
description: "One way cab from Pune to Goa offers cost-effective travel without return charges. Customers can book direct one-way rides easily. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Transparent pricing ensures affordability. Choose one-way cab services for Pune to Goa."
},
{
name: "Pune Goa Cab Service",
description: "Pune Goa cab service provides reliable transportation for vacation travel. Customers can book cabs for flexible travel plans. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Transparent pricing ensures affordability. Travel easily with Pune Goa cab services."
},
{
name: "Pune to Goa Cab Cost",
description: "Pune to Goa cab cost provides detailed pricing for travel planning. Customers can compare costs before booking rides. Affordable pricing ensures budget-friendly journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Choose cab services with transparent cost for Goa travel."
},
{
name: "Pune to Goa Cab Charges",
description: "Pune to Goa cab charges provide clear pricing details for long-distance travel. Customers can check charges before booking rides. Affordable pricing ensures cost-effective travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Choose cab services with transparent charges for Goa trips."
}
],

tableData: [
["Pune to Goa Cab Service","Pune to Goa Cab Booking"],
["Pune to Goa Rental Cabs","Pune to Goa One-Way Cab"],
["Pune to Goa Round Trip Cabs","Pune to Goa Luxury Taxi"],
["Pune to Goa Cabs","Pune to Goa Car Rental"],
["Pune to Goa Taxi","Pune to Goa Taxi Fare"],
["Pune to Goa Cab Package","Pune to Goa Cab Fare"],
["Best Cab Service from Pune to Goa","Cab Service from Pune to Goa"],
["Car Hire Pune to Goa","One Way Cab from Pune to Goa"],
["Pune Goa Cab Service","Pune to Goa Cab Cost"],
["Pune to Goa Cab Charges","Pune to Goa Cab Service"]
],



whychoose: [
  {
    WhyChooseheading: "Experienced Ghat & Coastal Route Drivers",
    WhyChoosedescription: "SRS Cab Service provides expert drivers experienced in Pune to Goa routes via Amboli, Chorla, and NH66, ensuring safe driving through ghats and coastal highways for a smooth journey."
  },
  {
    WhyChooseheading: "Affordable Pune to Goa Cab Pricing",
    WhyChoosedescription: "We offer budget-friendly Pune to Goa cab services with transparent pricing. Customers receive full fare details including tolls, state taxes, and driver allowance with no hidden charges."
  },
  {
    WhyChooseheading: "24/7 Cab Service Availability",
    WhyChoosedescription: "SRS Cab Service operates 24/7 for Pune to Goa cab bookings, making it convenient for night travel, weekend trips, and holiday vacations."
  },
  {
    WhyChooseheading: "Comfortable & AC Vehicles for Long Travel",
    WhyChoosedescription: "Our fleet includes clean, well-maintained, and air-conditioned vehicles designed for long-distance comfort, ensuring a relaxing journey from Pune to Goa."
  },
  {
    WhyChooseheading: "Flexible One Way & Round Trip Options",
    WhyChoosedescription: "We provide one-way cab service, round-trip bookings, and customized Goa travel packages from Pune based on your itinerary."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Choose from sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta, and Tempo Travellers suitable for couples, families, and group travel."
  },
  {
    WhyChooseheading: "Doorstep Pickup Across Pune",
    WhyChoosedescription: "We offer convenient pickup from homes, hotels, offices, and Pune Airport across all major areas including Hinjewadi, Wakad, Baner, Kharadi, and Hadapsar."
  },
  {
    WhyChooseheading: "Trusted Goa Trip Cab Service",
    WhyChoosedescription: "SRS Cab Service is trusted for Pune to Goa cab bookings due to reliable vehicles, experienced drivers, and comfortable long-distance travel experience."
  }
]
}

const faqData = [
  { question: "Do you provide Pune to Goa cab service?", answer: "Yes, SRS Cab Service offers reliable cab services from Pune to Goa for comfortable long-distance travel." },
  { question: "How far is Goa from Pune?", answer: "The distance between Pune and Goa is approximately 450 km and the journey takes around 8 to 10 hours depending on route and traffic." },
  { question: "Is Pune to Goa cab service available 24 hours?", answer: "Yes, our cab service operates 24/7 for flexible travel planning." },
  { question: "Which vehicles are available for Pune to Goa travel?", answer: "We offer sedan cars, SUVs like Ertiga and Innova, luxury Innova Crysta, and Tempo Travellers." },
  { question: "Can I book a one-way cab from Pune to Goa?", answer: "Yes, we provide both one-way and round-trip cab services." },
  { question: "Which routes are used for Pune to Goa travel?", answer: "Common routes include Amboli Ghat, Chorla Ghat, and NH66 coastal highway." },
  { question: "Are vehicles suitable for ghat travel?", answer: "Yes, all vehicles are well-maintained and suitable for ghat and long-distance travel." },
  { question: "Can I book the cab online?", answer: "Yes, you can easily book Pune to Goa cab service online or via phone." },
  { question: "Do you provide pickup from Pune home or hotel?", answer: "Yes, we provide doorstep pickup from homes, hotels, offices, and Pune Airport." },
  { question: "Are vehicles cleaned regularly?", answer: "Yes, all vehicles are regularly cleaned and sanitized for passenger safety." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Akshay Patil",
    feedback:
      "Booked SRS Cab Service for Goa trip from Pune. Amazing journey and driver handled ghat roads perfectly.",
    rating: 5
  },
  {
    id: 2,
    name: "Ms. Riya Mehta",
    feedback:
      "Best Pune to Goa cab service. Comfortable ride and perfect for family vacation.",
    rating: 5
  }
];

































const Images = [
{ place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "Pune-Cab-Service" },
{ place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "Pune-Taxi-Hire" },
{ place: "/images/keyword/3.jpg", text: "Pune Online Cabs Booking", link: "Pune-Online-Cabs-Booking" },
{ place: "/images/keyword/4.jpg", text: "Best Cabs Service in Pune", link: "Best-Cabs-Service-in-Pune" },
{ place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
{ place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
{ place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cab", link: "Pune-to-Mahabaleshwar-Cab" },
{ place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab", link: "Pune-to-Lonavala-Cab" },
{ place: "/images/keyword/9.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
{ place: "/images/keyword/10.jpg", text: "Pune to Shirdi Cab", link: "Pune-to-Shirdi-Cab" },
{ place: "/images/keyword/11.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
{ place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
{ place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cab", link: "Pune-to-Konkan-Darshan-Cab" },
{ place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
{ place: "/images/keyword/15.jpg", text: "Pune Outstation Cabs", link: "Pune-Outstation-Cabs" },
{ place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab", link: "Pune-to-Panchgani-Cab" },
{ place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
{ place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab", link: "Ashtavinayak-Darshan-Cab" },
{ place: "/images/keyword/19.jpg", text: "Pune to Nagpur Cab", link: "Pune-to-Nagpur-Cab" },
{ place: "/images/keyword/20.jpg", text: "Pune to Goa Cab", link: "Pune-to-Goa-Cab" },
{ place: "/images/keyword/21.jpg", text: "Pune to Ajanta Ellora Cab", link: "Pune-to-Ajanta-Ellora-Cab" },
{ place: "/images/keyword/22.jpg", text: "Pune to Satara Cabs", link: "Pune-to-Satara-Cabs" },
{ place: "/images/keyword/23.jpg", text: "Pune Airport Cabs", link: "Pune-Airport-Cabs" },
{ place: "/images/keyword/24.jpg", text: "Pune to Ayodhya Tour Package", link: "Pune-to-Ayodhya-Tour-Package" },
{ place: "/images/keyword/25.jpg", text: "Corporate Cab Service in Pune", link: "Corporate-Cab-Service-in-Pune" },
];











const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Goa Cab | SRS Cab",
  "description": "SRS Cab provides Pune to Goa cab services including one-way and round trips, luxury cabs, car rentals, and taxi packages. Book safe, comfortable, and affordable rides from Pune to Goa with 24x7 online booking. Perfect for personal, corporate, or holiday travel.",
  "brand": {
    "@type": "Brand",
    "name": "SRS Cab"
  },
  "offers": {
    "@type": "Offer",
    "url": "https://www.srscabservice.com/",
    "priceCurrency": "INR",
    "availability": "https://schema.org/InStock"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "2450"
  }
};








  return (
    <div>
      
<Helmet>
  <title>Pune to Goa Cab | Call +91 9011955415 | SRS Cab</title>
  <meta 
    name="description" 
    content="Book Pune to Goa cabs with SRS Cab. One-way, round trips, luxury cabs, car rentals, and taxi packages. Safe, comfortable, and affordable rides from Pune to Goa with 24x7 online booking." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/20.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#030706', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Srs Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2 d-flex">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
               <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Srs Cab Service</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Srs Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                        //   title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919011955415" className="pc-call">+91 9011955415</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919011955415"
          target="_blank"
          rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a href="tel:+919011955415" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@srscabservice.com" className="pc-email">
        booking@srscabservice.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-geo-alt-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Srs Cab Service</strong><br />
        Office no. 3 Mankar corner, kaspate chowk wakad Pune 411027
      </address>
    </section>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetogoacab;